import { RepeatIcon } from '@chakra-ui/icons';
import {
  Box,
  Flex,
  IconButton,
  SkeletonText,
  Stack,
  Text,
} from '@chakra-ui/react';
import { format, parseJSON } from 'date-fns';
import PropTypes from 'prop-types';
import { ReducerStatus } from 'utils/constants';
import { v4 as uuidv4 } from 'uuid';

function SubQuestLogs({ status, logs, handleReloadData, ...rest }) {
  return (
    <Box {...rest}>
      <Flex>
        <Text fontSize="xs" fontWeight="extrabold">
          LOGS
        </Text>

        {status !== ReducerStatus.LOADING && (
          <IconButton
            onClick={handleReloadData}
            aria-label="Reload table"
            variant="link"
            icon={<RepeatIcon />}
          />
        )}
      </Flex>

      <Stack mt={4} gap={5}>
        {status === ReducerStatus.LOADING
          ? [...Array(10)].map(() => (
              <SkeletonText
                key={uuidv4()}
                noOfLines={2}
                spacing="4"
                skeletonHeight="4"
              />
            ))
          : logs?.map((log) => (
              <Box key={log.id}>
                <Text fontSize="sm">
                  {log.initiator.name} has&nbsp;
                  <strong>{log.action.toLowerCase()}</strong> this sub-quest
                </Text>
                <Text as="sub" fontSize="xs" fontWeight={500}>
                  {format(parseJSON(log.dateCreated), 'MMMM d, yyyy (h:mm a)')}
                </Text>
              </Box>
            ))}
      </Stack>
    </Box>
  );
}

SubQuestLogs.propTypes = {
  status: PropTypes.string.isRequired,
  logs: PropTypes.array.isRequired,
  handleReloadData: PropTypes.func.isRequired,
};
export default SubQuestLogs;
